import React from 'react';

export type DrawerContextProps = {
  open: boolean;
  onClose: (event: MouseEvent) => void;
};

const DrawerContext = React.createContext<Partial<DrawerContextProps>>({});

export { DrawerContext };
